import { render, staticRenderFns } from "./PurchasesMain.vue?vue&type=template&id=3724c7b8&"
import script from "./PurchasesMain.vue?vue&type=script&lang=js&"
export * from "./PurchasesMain.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports